package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.TicketRespondState
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository


class GetTicketRespondStateUseCase(private val repo: TicketsRepository) {
    suspend operator fun invoke(ticketId: String): TicketRespondState =
        repo.getRespondState(ticketId)
}